import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ListFiltersBar } from '../shared/table/ListFiltersBar';
import { TablePagination } from '../shared/table/TablePagination';
import { CustomerStatsCards, CustomerTable } from './components';
import { useCustomerListScreen } from './hooks';
import {
    customerSearchFieldLabelMap,
    customerSearchFieldOptions,
    customerStatusClassMap,
    customerStatusOptions,
    formatCustomerDate,
} from './helpers';

export const CustomerListScreen = () => {
    const dispatch = useDispatch();
    const { token } = useSelector((state) => state.auth);
    const { statsCollapsed } = useSelector((state) => state.ui);

    const {
        customers,
        isLoading,
        error,
        pagination,
        statusSummary,
        searchTerm,
        searchField,
        statusFilter,
        rowsPerPage,
        setOffset,
        handleRowsPerPageChange,
        handleSearchTermChange,
        handleSearchFieldChange,
        handleStatusFilterChange,
        handleClearFilters,
    } = useCustomerListScreen({
        token,
        dispatch,
    });

    return (
        <>
            <CustomerStatsCards
                total={pagination.total}
                statusSummary={statusSummary}
                visible={statsCollapsed}
            />

            <div className="row">
                <div className="col-lg-12">
                    <div className="card stretch stretch-full card__no-border">
                        <div className="card-body pt-1">
                            <ListFiltersBar
                                searchField={searchField}
                                onSearchFieldChange={handleSearchFieldChange}
                                searchFieldOptions={customerSearchFieldOptions}
                                searchTerm={searchTerm}
                                onSearchTermChange={handleSearchTermChange}
                                statusFilter={statusFilter}
                                onStatusFilterChange={handleStatusFilterChange}
                                statusOptions={customerStatusOptions}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleRowsPerPageChange}
                                onClearFilters={handleClearFilters}
                            />

                            {error && (
                                <div className="alert alert-danger py-2" role="alert">
                                    {error}
                                </div>
                            )}

                            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
                                <div className="text-muted fs-12">
                                    {searchTerm.trim()
                                        ? `Resultados para ${customerSearchFieldLabelMap[searchField] || 'Búsqueda'}: "${searchTerm.trim()}"`
                                        : 'Listado general de clientes'}
                                </div>
                                <div className="text-muted fs-12">Mostrando {customers.length} de {pagination.total}</div>
                            </div>

                            <CustomerTable
                                customers={customers}
                                isLoading={isLoading}
                                statusClassMap={customerStatusClassMap}
                                formatDate={formatCustomerDate}
                            />

                            <TablePagination
                                total={pagination.total}
                                limit={pagination.limit}
                                offset={pagination.offset}
                                hasNext={pagination.hasNext}
                                hasPrev={pagination.hasPrev}
                                onOffsetChange={setOffset}
                                isLoading={isLoading}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
